<template>
    <div class="clearfix" id="home-box">
        <nav-header></nav-header>
        <div class="row mx-0">
            <div class="home-swiper-box">
                <img src="../../public/images/impress/bannar.png" alt="" />
                <!-- <div class="home-swiper-text">
                    时差印象
                </div> -->
            </div>
        </div>
        <div class="row mx-0 px-0 home-icon-container">
            <div class="home-icon-box">
                <div class="home-icon-content">
                    <div>
                        苏州时差设计制作有限公司创办于2012年，位于国家历史名城 “人间天堂”的苏州。<br>
                        时差设计由主题空间、品牌形象、样本画册三个部门组成，公司着重以人才为中心，<br>
                        每个部门都由精英团队组成，在主题空间设计、企业形象设计、平面设计方面形成了独树一帜的专业风格和品牌号召力。<br>
                        时差设计从志造到智造再到质造控制都具有系统完善的流程体系，从而缩短客户与目标之间的差距，建立领先对手的品牌<br>
                        营销力和竞争力。
                    </div>

                    <div class="ry-wrap">
                        <div class="ry-box">时差荣誉</div>
                        <div>
                            <p>★中国建筑装饰协会软装陈设分会学术委员 <span></span>★中国建筑文化研究会“装饰艺术学科建设高级专家”</p>
                            <p>★第五届日本IDPA AWARD 国际先锋设计大奖 <span></span>★最具影响力十大设计师</p>
                            <p>★第十八届设博会华鼎杯作品金奖 <span></span>★作品入选麦迪逊丛书《国际设计年鉴》</p>
                            <p>★苏州平面设计师协会理事单位 <span></span>★苏州工艺美院职业技术学院校企合作单位</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mx-0">
            <div class="home-swiper-box">
                <img src="../../public/images/impress/bannar1.jpg" alt="" />
            </div>
        </div>
        <div class="row mx-0 px-0 home-icon-container">
            <div class="home-icon-box">
                <div class="home-icon-content">
                    <h3>
                        时差智造
                    </h3>
                </div>
                <div class="home-flex-box text-center">
                    <div class="card border-0 mb-2 col-2 col-lg-2" v-for="(item,key) in iconData" :key="key">
                        <div class="card-body pb-0">
                            <h4 class="mb-0">{{item.name}}</h4>
                            <p>{{item.desc}}</p>
                        </div>
                    </div>
                </div>
                <div class="home-icon-content home-icon-content1">
                    <h3>
                        <span>时差设计观点</span>
                    </h3>
                    <div>
                        设计是解决问题的一个过程，我们坚信形式是为内容服务的，<br>
                        把每一个东西做到漂亮只是基础，具备情理中意料之外而为之惊叹的创意，<br>
                        不仅能够降低品牌的传播成本，更是让品牌在红海中看见蓝光。<br>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="row mx-0 home-bg2-box">
            <div class="home-swiper-box">
                <img src="../../public/images/impress/bg2.png" alt="" />
            </div>
        </div> -->
        <div class="row mx-0">
            <div class="home-swiper-box">
                <img src="../../public/images/impress/bg3.png" alt="" />
            </div>
        </div>
        <div class="row mx-0 px-0 home-icon-container">
            <div class="home-icon-box">
                <div class="home-icon-content">
                    <h3 class="my-0">
                        时差质造
                    </h3>
                </div>
                <div class="home-icon-content home-icon-content2">
                    <h3>
                        <span>起于初心</span>
                        <span>回归匠心</span>
                    </h3>
                </div>
                <div class="home-icon-content home-icon-content1">
                    <h3 class="home-new-bg">
                        <span>时差制造工厂</span>
                    </h3>
                    <div>
                        时差制造工厂是一个以展览、展厅、导视工程为中心具有多产业构成的制造工厂。<br>
                        在工程、制作与相关服务方面具有丰富的经验和齐全的专业配备，<br>
                        秉承多年主题空间和大型展馆项目的经验和严谨的工作流程，确保各项目的完美落地。<br>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mx-0">
            <div class="home-swiper-box">
                <img src="../../public/images/impress/bg11.jpg" alt="" />
            </div>
        </div>

        <div class="row mx-0 px-0 home-icon-container">
            <div class="home-icon-box">
                <div class="home-icon-content">
                    <h3 class="my-0">
                        时差志造
                    </h3>
                </div>
                <!-- <div class="home-icon-content home-icon-content2">
                    <h3>
                        <span>起于初心</span>
                        <span>回归匠心</span>
                    </h3>
                </div> -->
                <div class="home-icon-content home-icon-content1">
                    <h3 class="home-new-bg-2" style="height: 282px;">
                    </h3>
                    <div>
                        时差设计立志始终坚持“讲究不将就”的时差精神，<br>
                        <span style="font-weight: bold;">深耕于高品质党政空间的全案设计打造，</span><br>
                        崇尚匠人精神，追求臻品品质，以“主题+艺术+功能”相融合，致力为党群服务中心，社区服务中心、新时代文明实践、综治中心、妇女儿童之家、<br>
                        职工服务中心、融媒体中心、乡村振兴、村史馆等提供主题空间定制化服务。
                    </div>
                </div>
            </div>
        </div>

        <div class="row mx-0">
            <div class="home-swiper-box">
                <img src="../../public/images/impress/bg12.jpg" alt="" />
            </div>
        </div>
        
        <div class="row mx-0 px-0 home-icon-container">
            <div class="home-icon-box">
                <div class="home-icon-content">
                    <h3 style="margin-top: 0;color: #b29973">
                        时差策略
                    </h3>
                    <div>
                        <span style="font-weight: bold;">西部设计大开发</span><br>
                        2019年起，由时差设计创始人张建华先生成功主持策划了时差设计“西部设计大开发”的项目计划，通过“一个项目了解一座城，交一帮知心朋<br>
                        友”作为项目的宗旨，成功开辟了新疆、宁夏、西藏、内蒙、陕西等城市，带领时差设计团队走遍祖国西部，完成了很多西部项目。<br><br>

                        <span style="font-weight: bold;">设计长三角</span><br>
                        2022年起，时差设计“设计长三角”的项目推进计划启动，通过多点突破，强强连手，全面发力的形式，推动发展时差设计跨越式高质量发展。<br>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mx-0">
            <div class="home-swiper-box">
                <img src="../../public/images/impress/bg5.png" alt="" />
            </div>
        </div>
        <div class="row mx-0 px-0 home-icon-container">
            <!-- <div class="home-icon-box">
                <div class="home-icon-content3">
                    <h3 style="margin-top: 0;">
                        We have always believed that
                    </h3>
                    <div>
                        <p>创意来源于生活中的每一个角落</p>
                        <p>只有会生活的设计师才是优秀的设计师</p>
                    </div>
                </div>
            </div> -->
            <div class="row mx-0 px-0 home-icon-container">
            <div class="home-icon-box">
                <div class="home-icon-content">
                    <h3 style="margin-top: 0; color: #b29973">
                        时差环境
                    </h3>
                    <div>
                        时差设计一直坚信创意源于生活，设计即生活，<br>
                        一个懂得生活、热爱生活、享受生活的设计师才能更好的创作出有灵气、有生命力的作品，<br>
                        我们只有活的更好，才能做的更好。所以时差设计一直在为设计师营造一个轻松、赋有艺术氛围的工作环境而不断的努力着，能够把艺术、图书、<br>
                        美食、和娱乐带入工作中，从而能够在愉快中安逸地生活、快乐地工作着。
                    </div>
                </div>
            </div>
        </div>
        </div>
        <div class="row mx-0">
            <div class="home-swiper-box">
                <img src="../../public/images/impress/bg6.png" alt="" />
            </div>
        </div>
        <div class="row mx-0 home-bg2-box">
            ......
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
// @ is an alias to /src
import NavHeader from "@/components/navHeader.vue";
import Footer from "@/components/footer.vue";

export default {
    name: "Impress",
    components: {
        NavHeader,
        Footer
    },
    data() {
        return {
            //icon数据
            iconData: [
                {
                    name: "讲究不将就",
                    desc: "时差设计精神"
                },
                {
                    name: "先做人、再做事、后作品",
                    desc: "时差工作方式"
                },
                {
                    name: "人品、作品、臻品",
                    desc: "时差设计理念"
                }
            ]
        };
    },
    created() {},
    methods: {},
    mounted() {
    }
};
</script>
<style lang="scss" scoped>
#home-box {
    overflow: hidden;
    margin-top: 80px;

    //轮播样式
    .home-swiper-box {
        width: 100%;
        overflow: hidden;
        position: relative;

        img {
            width: 100%;
            // max-height: 450px;
            // height: 700px;
        }

        .home-swiper-text {
            font-size: 55px;
            text-align: center;
            width: 100%;
            height: 160px;
            color: #fff;
            position: absolute;
            top: 30%;
            left: -16%;
            right: 0;
            bottom: 0;
            line-height: 2;
        }
    }

    .home-icon-container {
        margin: 100px auto;
        width: 100%; 

        .home-icon-box {
            width: 1200px;
            height: 100%;
            margin: 0 auto;

            .home-flex-box {
                margin-top: 100px;
                display: flex;
                justify-content: space-around;

                .card {
                    position: relative;
                    background: url('../../public/images/impress/ellipse.png') top center no-repeat;
                    color: #333333;
                    height: 140px;
                    text-align: center;;
                    padding: 0;
                }
                
                h4 {
                    font-size: 26px;
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    transform: translateX(-50%);
                    white-space: nowrap;
                }

                p {
                    font-size: 16px;
                    position: absolute;
                    bottom: 30px;
                    left: 50%;
                    transform: translateX(-50%);
                }
            }

            .home-icon-content {
                h3 {
                    margin: 50px auto;
                    color: #cc0000;
                    font-size: 36px;
                    line-height: 40px;

                    // span {
                    //     padding: 0 30px;

                    //     &:last-child {
                    //         border-left: 1px solid #9A9A9A;
                    //     }
                    // }
                }

                div {
                    font-size: 16px;
                    line-height: 30px;
                    color: #333333;
                }
            }

            .ry-box{
                margin: 50px auto;
                color: #b29973 !important;
                font-size: 36px !important;
                line-height: 40px;
            }

            .ry-wrap{
                p{
                    color: #b29973;
                    font-size: 16px;
                    display: block;
                    overflow: hidden;
                }

                span{
                    width: 20px;
                    display: inline-block;
                }
            }

            .home-icon-content1 {
                h3 {
                    font-size: 16px;
                    color: #333;
                    font-weight: bold;
                    background: url('../../public/images/impress/bg1.png') top center no-repeat;
                    height: 325px;
                    position: relative;

                    &.home-new-bg {
                        background-image: url('../../public/images/impress/bg2.png');
                        height: 375px;
                    }

                    &.home-new-bg-2 {
                        background-image: url('../../public/images/impress/bg3.jpg');
                        height: 375px;
                    }

                    span {
                        position: absolute;
                        bottom: 0;
                        left: 50%;
                        transform: translateX(-50%);
                    }
                }
            }

            .home-icon-content2 {
                h3 {
                    position: relative;
                    font-size: 26px;
                    color: #666;
                    height: 235px;

                    span {
                        position: absolute;
                        width: 235px;
                        height: 235px;
                        border: 2px dotted #cc0000;
                        border-radius: 50%;
                        line-height: 235px;

                        &:first-child {
                            left: 33%;
                        }
                    }
                }
            }

            .home-icon-content3 {
                h3 {
                    font-size: 16px;
                    color: #cc0000;
                    margin-bottom: 20px;
                }

                div {
                    font-size: 26px;
                    color: #333333;
                    line-height: 40px;

                    p {
                        margin-bottom: 1rem;
                    }
                }
            }
        }
    }

    .home-bg2-box {
        height: 230px;
        -webkit-writing-mode: vertical-rl;
        writing-mode: vertical-rl;
        font-weight: bold;
        font-size: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
    }
    
    .impress-content-box {
        width: 920px;
        margin: 0 auto 100px;

        .impress-content-img {
            margin-top: 80px;
        }

        .impress-content-center {
            width: 920px;
            margin: 80px auto 0;
            .impress-left-content {
                float: left;

                .impress-common-content {
                    font-size: 16px;
                    color: #333333;
                    line-height: 30px;
                    height: 255px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

                // .impress-common-img {

                // }

                &:last-child {
                    float: right;
                }
            }
        }
    }
}
@media screen and (max-width: 1260px){
    #home-box  {
        .home-icon-container .home-icon-box {
            width: auto;
            padding: 0 20px;
        }
    }
}
</style>
